import React from 'react';

export default function CareerDescription(props) {
  const { description } = { ...props };

  return (
    <div className="career-description margin-bottom border-bottom">
      {description}
    </div>
  );
}
